import { FC, useState } from "react";
import { getEntryUrl, translate } from "@kaltura/mediaspace-shared-utils";
import TopBanner from "../top-banner/TopBanner";
import PreviewWelcomeManager from "../welcome/PreviewWelcomeManager";
import { ButtonAnalyticsProvider } from "@kaltura/mediaspace-shared-hooks";
import { liveStudioApplicationFeature } from "../analytics";

export interface AttendeeTopBannerProps {
    entryName: string;
    entryId: string;
}

export const AttendeeTopBanner: FC<AttendeeTopBannerProps> = ({ entryName, entryId }) => {
    // State for banner visibility
    const [isTopBannerVisible, setIsTopBannerVisible] = useState(true);

    if (!isTopBannerVisible) return null;

    return (
        <ButtonAnalyticsProvider location={"Live studio banner"} applicationFeature={liveStudioApplicationFeature}>
            <TopBanner
                bannerText={translate("This is the attendee view for: %1", [entryName])}
                buttonText={translate("Studio view")}
                buttonUrl={getEntryUrl(entryId, undefined, entryName)}
                buttonTarget={"_self"}
                onClose={() => setIsTopBannerVisible(false)}
                ctaAnalyticsValue={"Studio View"}
                closeButtonAnalyticsValue={"Close attendee view banner"}
            />
            <PreviewWelcomeManager />
        </ButtonAnalyticsProvider>
    );
};

export default AttendeeTopBanner;
